import { PublishType } from '../../types';

export const getPublishTypeLabel = (type: PublishType): string => {
  switch (type) {
    case PublishType.PRODUCT:
      return 'Product data only';
    case PublishType.PRICING:
      return 'Pricing data only';
    case PublishType.PRODUCT_AND_PRICING:
      return 'Product & Pricing data';
    default:
      return '';
  }
};
